export { default } from "./ReviewsHeader";
